// variant-fix.js — Cubbie, 11/10/2026.
// O global.js novo (15/09) deixou de tratar <variant-radios>/<variant-selects> do main-product antigo:
// ao escolher uma variante, a foto, o preço e o input name="id" não mudavam (o carrinho recebia a 1.ª variante).
(function () {
  if (window.__cubVariantFix) return;
  window.__cubVariantFix = true;
  if (!customElements.get('variant-radios')) customElements.define('variant-radios', class extends HTMLElement {});

  function selectedOptions(el) {
    if (el.tagName === 'VARIANT-SELECTS') return [...el.querySelectorAll('select')].map((s) => s.value);
    return [...el.querySelectorAll('fieldset')].map((f) => (f.querySelector('input:checked') || {}).value);
  }

  function handle(el) {
    const json = el.querySelector('script[type="application/json"]');
    if (!json) return;
    const variants = JSON.parse(json.textContent);
    const opts = selectedOptions(el);
    const v = variants.find((x) => x.options.every((o, i) => o === opts[i]));
    if (!v) return;
    const sec = el.dataset.section;
    const form = document.getElementById('product-form-' + sec);

    document.querySelectorAll('#product-form-' + sec + ' input[name="id"], #mainSelectedProduct').forEach((i) => {
      i.value = v.id;
      i.dispatchEvent(new Event('change', { bubbles: true }));
    });
    if (el.dataset.url) window.history.replaceState({}, '', el.dataset.url + '?variant=' + v.id);

    if (v.featured_media) {
      const gallery = document.getElementById('MediaGallery-' + sec);
      if (gallery && gallery.setActiveMedia) gallery.setActiveMedia(sec + '-' + v.featured_media.id, true);
    }

    fetch(el.dataset.url + '?variant=' + v.id + '&section_id=' + sec)
      .then((r) => r.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const price = document.getElementById('price-' + sec);
        const newPrice = doc.getElementById('price-' + sec);
        if (price && newPrice) price.innerHTML = newPrice.innerHTML;
        const btn = form && form.querySelector('[name="add"]');
        const newBtn = doc.querySelector('#product-form-' + sec + ' [name="add"]');
        if (btn && newBtn) {
          btn.disabled = newBtn.disabled;
          const span = btn.querySelector('span');
          const newSpan = newBtn.querySelector('span');
          if (span && newSpan) span.textContent = newSpan.textContent;
        }
      })
      .catch(() => {});
  }

  document.addEventListener('change', (e) => {
    const el = e.target.closest && e.target.closest('variant-radios, variant-selects');
    if (el) handle(el);
  });
})();
